var ww;
var wh;
var hh;
var hhRight;


function preventDefault(e) {
	e = e || window.event;
	if (e.preventDefault)
		e.preventDefault();
	e.returnValue = false;  
}


var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefaultForScrollKeys(e) {
	if (keys[e.keyCode]) {
		preventDefault(e);
		return false;
	}
}

function bodyScroll(){
	if ($("body").hasClass("no")){
		console.log("NO");
		$("body").removeClass("no").css("overflow","");
	} else {
		console.log("YES");
		$("body").addClass("no").css("overflow", "hidden");
	}
}

/*Prevent scroll when overlay is visible*/
function disableScroll() {
        if (window.addEventListener) // older FF
        	window.addEventListener('DOMMouseScroll', preventDefault, false);
        window.onwheel = preventDefault; 
        window.onmousewheel = document.onmousewheel = preventDefault; 
 //  window.ontouchmove  = preventDefault; 
 document.onkeydown  = preventDefaultForScrollKeys;
}

function enableScroll() {
	if (window.removeEventListener)
		window.removeEventListener('DOMMouseScroll', preventDefault, false);
	window.onmousewheel = document.onmousewheel = null; 
	window.onwheel = null; 
	window.ontouchmove = null;  
	document.onkeydown = null;  
}


function headerResize(){

	hh = $("header").outerHeight();
	
}




function resizeFunction(){
	ww = $(window).width();
	wh = $(window).height();
}


$(window).on("resize",function(){
	resizeFunction();
	//headerMsg();
	headerResize();
	
});

$(window).on("load",function(){
	resizeFunction();
	//headerMsg();
	headerResize();
	

	if ($(window).scrollTop() >= hh) {
		$("header").addClass("fixed");
	}
});



$(window).on("scroll mousewheel",function(){

	st = $(window).scrollTop();
	limit = hh;

});

// $(".header-mobile-menu").on("click",function(){
// 	$(".header-nav").toggleClass("active");
// 	$(this).toggleClass("active");
// 	$(".global-overlay").toggleClass("open");
// });

// $(".header-mobile-search").on("click",function(event){
// 	event.preventDefault();
// 	$(".header-mobile-search-con").toggleClass("active");
// 	$(this).toggleClass("active");
// 	$(".global-overlay").toggleClass("open");

// });

$.fn.hasAttr = function(name) {  
	return this.attr(name) !== undefined;
};

$(".global-select-div-selection").change(function(){
	t = $(this);
	nn = t.find("option:selected").text();
	t.prev().text(nn);
});


 $(".product-quantity-panel-plus").on("click",function(){
  q = $(this).prev();
  
  var value = parseInt(q.val(), 10);
  value = isNaN(value) ? 0 : value;
  value++;

  q.val(value);
});

 $(".product-quantity-panel-minus").on("click",function(){
  q = $(this).next();
  

  var value = parseInt(q.val(), 10);
  value = isNaN(value) ? 1 : value;
  if(value > 1)
  {
    value--;
    q.val(value);
  }

});


$('.header-top-buttons-each').on('click',function(event){
	toTrigger = $("#" + $(this).attr('data-id'));

	if (!$(this).hasClass('redirect')) {
		event.preventDefault();

		if ($(this).hasClass('is-triggered')) {
			console.log('no');
			$("header").find('.triggered').removeClass('triggered');
			$('.header-top-buttons').find('.is-triggered').removeClass('is-triggered');
			$('.global-overlay').removeClass('open');

			if ($(this).hasClass('header-search')) {
			$('.header-search-desktop').find('.header-search').blur();
		}
		} else {
			console.log('yes');
			$('header').find('.triggered').removeClass('triggered');
			$('.header-top-buttons').find('.is-triggered').removeClass('is-triggered');
			$('.global-overlay').addClass('open');
			$(this).addClass('is-triggered');
			toTrigger.addClass('triggered');

			if ($(this).hasClass('header-search')) {
			$('.header-search-desktop').find('.header-search').focus();
		}

		}


	}
});

$('.global-overlay').on('click',function(){
	$("header").find('.triggered').removeClass('triggered');
	$('.header-top-buttons').find('.is-triggered').removeClass('is-triggered');
	$(this).removeClass('open');
});
